import React from 'react';
import {Card, Row} from 'react-bootstrap';
import {useLoaderData} from 'react-router-dom';
import {usePreloadedQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import DashboardItem from "./DashboardItem";
import NetworksTable from "../networks/NetworksTable";
const Dashboard = () => {
    const loader = useLoaderData();
    const data = usePreloadedQuery(graphql`
        query DashboardQuery {
            allNetworks {
                ...NetworksTable_Networks
            }
            dashboard {
                activeContractCount
                uniqueNpiForFacilities
                uniqueNpiForPractitioners
            }
        }
    `, loader.dashboardQuery)
    
    return (<>
            <Card className={"mb-3"}>
                <Card.Body className={"px-xxl-0 pt-4"}>
                    <Row className={"g-0"}>
                        <DashboardItem amount={data.dashboard.activeContractCount} 
                                       title={"Active Contracts"} 
                                       className={"border-sm-end border-bottom border-xl-bottom-0 p-xl-0 ps-sm-0"}
                                       icon={"pen-nib"}
                                       color={"primary"}
                                       
                        />
                        <DashboardItem amount={data.dashboard.uniqueNpiForFacilities}
                                       title={"Unique Facilities"}
                                       className={"border-xl-end border-bottom border-xl-0 pt-4 pt-sm-0 pe-sm-0 p-xl-0"}
                                       icon={"building"}
                                       color={"info"}
                        />
                        <DashboardItem amount={data.dashboard.uniqueNpiForPractitioners}
                                       title={"Unique Practitioners"}
                                       className={"pt-4 p-xl-0 pb-sm-0 ps-sm-0"}
                                       icon={"user-md"}
                                       color={"success"}
                        />
                    </Row>
                </Card.Body>
            </Card>
            <NetworksTable networks={data.allNetworks} />
        </>
    )
}
export default Dashboard